import { useState, type ReactNode, type RefObject } from "react";

// Vỏ modal chung cho 3 form nhập liệu. Class name giữ nguyên bản innerHTML cũ
// (styles.css chỉ style theo class, không theo id).
//
// Form để UNCONTROLLED và đọc bằng FormData — không phải 13 useState. Lý do:
//   - đúng bản cũ, ít chỗ để lệch hành vi
//   - form Log RTO cần "điền vào ô đang TRỐNG" khi dán ticket Teams, việc đó
//     tự nhiên với input uncontrolled (đọc el.value) và rất lằng nhằng nếu
//     mọi field là state
export type ModalProps = {
  title: string;
  submitLabel?: string;
  wide?: boolean;
  onClose: () => void;
  /** Throw để hiện lỗi trong form và giữ modal mở. */
  onSubmit: (fd: FormData) => Promise<void>;
  /** Cho Log RTO: cần chạm <form> để paste-fill. */
  formRef?: RefObject<HTMLFormElement | null>;
  /** Khoá Save khi form chưa sẵn sàng (VD dropdown recruiter đang tải). */
  submitDisabled?: boolean;
  children: ReactNode;
};

export function Modal({
  title, submitLabel = "Save", wide, onClose, onSubmit, formRef, submitDisabled, children,
}: ModalProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <div
      className="modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className={wide ? "modal modal-wide" : "modal"}>
        <div className="modal-head">
          <h2>{title}</h2>
          <button className="btn-icon" type="button" onClick={onClose}>✕</button>
        </div>
        <form
          id="modal-form"
          ref={formRef}
          onSubmit={async (e) => {
            e.preventDefault();
            const fd = new FormData(e.currentTarget);
            setError(null);
            setBusy(true);
            try {
              await onSubmit(fd);
              onClose();
            } catch (err) {
              setError(err instanceof Error ? err.message : String(err));
              setBusy(false);
            }
          }}
        >
          {children}
          {error ? <p className="form-error" id="form-error">{error}</p> : null}
          <div className="modal-foot">
            <button type="button" className="btn-plain" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" id="modal-submit"
              disabled={busy || submitDisabled}>
              {busy ? "Saving…" : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ---- field dùng lại giữa các form ----

export function NumField({ name, label }: { name: string; label: string }) {
  return (
    <label className="f-field f-num">
      <span>{label}</span>
      <input type="number" name={name} min="0" step="1" defaultValue="0" required />
    </label>
  );
}

export function TextField(
  { name, label, placeholder = "" }: { name: string; label: string; placeholder?: string },
) {
  return (
    <label className="f-field">
      <span>{label}</span>
      <input type="text" name={name} placeholder={placeholder} />
    </label>
  );
}

export function PositionSelect({ positions }: { positions: readonly string[] }) {
  return (
    <label className="f-field">
      <span>Position</span>
      <select name="position">
        {positions.map((p) => <option key={p}>{p}</option>)}
      </select>
    </label>
  );
}
